module.exports = __webpack_public_path__ + "img/close.fdc56a55.png";